module.exports = require("xtend");


//////////////////
// WEBPACK FOOTER
// external "xtend"
// module id = 83
// module chunks = 0